import React from "react";

import { string, object, func, bool, array } from "prop-types";

import { MultiInput, Button, Loading, TextFieldGroup } from "../../../common";
import SpacedOutText from "../../../common/SpacedOutText";

import * as style from "./styles.module.scss";
import RadioButton from "../../../common/RadioButton";

const PayrollUpdateForm = ({
  isDBSConsentVisible,
  bankName,
  accountNumber,
  sortCode,
  accountName,
  dbsConsent,
  nationalInsuranceNo,
  taxTypeEmployeeStatement,
  validation,
  handleChange,
  onSubmit,
  loading,
  taxTypeOptions,
  blurredElements,
  setBlurred,
  hasErrors,
}) => (
  <form>
    <section className="mb-2">
      <div className={style.sectionCard}>
        <div className={`form-group ${style.formGroup}`}>
          <div className="d-flex align-items-baseline">
            <label
              htmlFor="nationalInsuranceNo"
              className={
                blurredElements.nationalInsuranceNo &&
                validation.nationalInsuranceNo
                  ? style.redLabel
                  : ""
              }
            >
              National Insurance Number
            </label>
          </div>
          <TextFieldGroup
            classes="register_field col-6 col-sm-4"
            value={nationalInsuranceNo}
            placeholder="e.g. QQ123456C"
            validationMessages={
              blurredElements.nationalInsuranceNo &&
              validation.nationalInsuranceNo
            }
            validationMessageIsRed={true}
            onChange={(e) => {
              handleChange("nationalInsuranceNo", e.target.value.trim());
            }}
            onBlur={() => {
              setBlurred("nationalInsuranceNo");
            }}
          />
        </div>
        <div className="d-flex justify-content-end w-100">
          <Button
            id="submit-payroll-button"
            classes={`btn btn-primary btn-block col-12 col-sm-3 col-lg-2`}
            onClick={onSubmit}
            disabled={hasErrors}
          >
            {loading ? <Loading /> : "Save"}
          </Button>
        </div>
      </div>
    </section>
    <section>
      <div className={style.sectionCard}>
        <h3 className={style.updateHeader}>
          Please contact your local branch to update these details
        </h3>
        <div className={`form-group ${style.formGroup} ${style.disabled}`}>
          <div className="d-flex align-items-baseline">
            <label htmlFor="bankName">Name of bank</label>
          </div>
          <TextFieldGroup
            classes="register_field col-12 col-md-6"
            value={bankName}
            isDisabled={true}
            onChange={() => {}}
          />
        </div>
        <div className={`form-group ${style.formGroup} ${style.disabled}`}>
          <div className="d-flex align-items-baseline">
            <label
              htmlFor="accountNumber"
              className={validation.accountNumber ? style.redLabel : ""}
            >
              Account Number
            </label>
          </div>
          <TextFieldGroup
            classes="register_field col-6 col-md-4"
            value={accountNumber}
            isDisabled={true}
            onChange={() => {}}
          />
        </div>
        <div className={`form-group ${style.formGroup} ${style.disabled}`}>
          <div className="d-flex align-items-baseline">
            <label
              htmlFor="sortCode"
              className={validation.sortCode ? style.redLabel : ""}
            >
              Sort Code
            </label>
          </div>
          <MultiInput
            classes="register_field"
            value={sortCode}
            numberOfInputs={3}
            placeholder="987654"
            inputId="sortCode"
            onChange={() => {}}
            isDisabled={true}
          />
        </div>
        <div className={`form-group ${style.formGroup} ${style.disabled}`}>
          <div className="d-flex align-items-baseline">
            <label htmlFor="accountName">Name on account</label>
          </div>
          <TextFieldGroup
            classes="register_field col-12 col-md-6"
            value={accountName}
            onChange={() => {}}
            isDisabled={true}
          />
        </div>
        <h4 className={style.statementSectionHeader}>Employee statement</h4>
        {taxTypeOptions
          .filter((option) => taxTypeEmployeeStatement === option.value)
          .map((option) => (
            <div key={option.value} className={style.statement}>
              <h2 className={style.title__disabled}>{option.title}</h2>
              <SpacedOutText>{option.text}</SpacedOutText>
            </div>
          ))}

        {isDBSConsentVisible && (
          <div className="mt-1">
            <h4 className={style.statementSectionHeader}>DBS Consent</h4>
            <div className={style.statement}>
              <SpacedOutText>
                <span>
                  I consent to the DBS (formerly CRB) checking the details I
                  have provided in support of this application against the data
                  sources specified in the notes for guidance, in order to
                  verify my identity and process this application. These details
                  may be recorded and used to assist other organisations for
                  identity and verification purposes. I agree to an amount of
                  £30.00 will be deducted from my first weeks salary unless
                  otherwise stated in my starter letter.{" "}
                </span>
              </SpacedOutText>
              <RadioButton
                isChecked={dbsConsent === true}
                onClick={() => {
                  handleChange("dbsConsent", true);
                }}
                label={"Yes"}
                isDisabled={true}
              />
              <RadioButton
                isChecked={dbsConsent === false}
                onClick={() => {
                  handleChange("dbsConsent", false);
                }}
                label={"No"}
                isDisabled={true}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  </form>
);

PayrollUpdateForm.propTypes = {
  isDBSConsentVisible: bool.isRequired,
  bankName: string.isRequired,
  accountNumber: string.isRequired,
  sortCode: string.isRequired,
  accountName: string.isRequired,
  nationalInsuranceNo: string.isRequired,
  dbsConsent: bool,
  taxTypeEmployeeStatement: string.isRequired,
  validation: object.isRequired,
  handleChange: func.isRequired,
  isTaxTypeChoiceDisabled: bool,
  onSubmit: func,
  loading: bool,
  taxTypeOptions: array,
  blurredElements: object,
  setBlurred: func,
  hasErrors: bool,
};

export default PayrollUpdateForm;
